module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2ca"
  }, [_c('strong', [_vm._v("TIMELINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1733"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("Molasses Act")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1754"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("French and Indian War begins")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1764"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("Sugar Act")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1764"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("Currency Act")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("February: Stamp Act bill passed in Parliament")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("March: First Quartering Act issued")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("July: Sons of Liberty founded in MA")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("August: Raid on Hutchinson House, Boston")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("September: Sons of Liberty founded in NYC")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1765"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("November: Stamp Act goes into effect")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1766"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("March: Stamp Act repealed; Declaratory Act issued")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1766"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("August: Gage’s Army loots and burns Western part of Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1766"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("August: Liberty Boys rally 3,000 in New York City; Isaac Sears wounded")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1770"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("Boston Massacre")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1773"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("Tea Act, then Boston Tea Party")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1775"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("April: Paul Revere, William Dawes, Samuel Prescott ride (Battle of Lexington and Concord)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "float_toc"
  }, [_vm._v("1775"), _c('span', {
    staticClass: "space"
  }), _vm._v(" — "), _c('span', {
    staticClass: "space"
  })]), _vm._v("War of Independence begins")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7cbeea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/timeline.vue
// module id = 66
// module chunks = 0